import { Link } from "react-router-dom";
import { usePricing } from "../../context/PricingContext";
import { useI18n } from "../../i18n";
import { Button } from "../ui/button";
import { useCMSContent } from "../../hooks/useCMSContent";
import { ArrowRight } from "lucide-react";

const CTASection = () => {
  const { data: cms } = useCMSContent("landing_json");
  const { localizeText, priceLabelSemantic, chargeNote } = usePricing();
  const { t } = useI18n();
  const c = cms?.cta_final || {
    title: "Empieza hoy y protege lo que importa.",
    subtitle: "",
    button_label: "Crear mi AvisoCar",
    note: "",
  };

  return (
    <section className="bg-white py-20 md:py-28" data-testid="cta-final-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-[2rem] bg-[#0B2545] px-7 py-14 text-center sm:px-14 md:py-20">
          <div
            className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full opacity-40 blur-3xl"
            style={{ background: "radial-gradient(circle, #1B84FF 0%, rgba(11,37,69,0) 70%)" }}
            aria-hidden="true"
          />
          <div className="relative">
            <h2
              className="mx-auto mb-5 max-w-3xl text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl"
              data-testid="cta-final-title"
            >
              {c.title}
            </h2>
            {c.subtitle && (
              <p className="mx-auto mb-9 max-w-2xl text-base text-slate-300 md:text-lg" data-testid="cta-final-subtitle">
                {c.subtitle}
              </p>
            )}
            <Link to="/register">
              <Button
                className="h-auto whitespace-normal rounded-full bg-[#1B84FF] px-10 py-6 text-base font-semibold text-white shadow-[0_14px_36px_rgba(27,132,255,0.4)] transition-transform hover:-translate-y-0.5 hover:bg-[#0F6FDB]"
                data-testid="cta-final-btn"
              >
                {`${(localizeText(c.button_label) || "Crear mi AvisoCar")
                  .replace(/\s*(por|desde|from|dès|a partir de)?\s*(S\/|EUR|INR|USD|₹)?\s*[\d.,]*\s*$/i, "")
                  .trim()}${priceLabelSemantic(6) ? ` — ${t("pricing.from")} ${priceLabelSemantic(6)}` : ""}`}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
            {c.note && <p className="mt-4 text-sm text-slate-400" data-testid="cta-final-note">{c.note}</p>}
            {chargeNote(6) && (
              <p className="mx-auto mt-2 max-w-xl text-xs text-slate-500" data-testid="cta-final-charge-note">
                {chargeNote(6)}
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
